import { useMutation, useQueryClient } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const addComments = (postData) => {
  return http().post(endpoints.comments.postComments, postData);
};

export function usePostComments() {
  const queryClient = useQueryClient();
  return useMutation(addComments, {
    onSuccess: () => {
      queryClient.invalidateQueries(["fetchComments"]);
    },
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
